/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'Label'>;
const hooks = useModelQueries(schema, 'Label');

export const useAggregateLabel: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountLabel: Hooks['useCount'] = hooks.useCount;
export const useCreateLabel: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyLabel: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnLabel: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteLabel: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyLabel: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsLabel: Hooks['useExists'] = hooks.useExists;
export const useFindFirstLabel: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyLabel: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueLabel: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByLabel: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyLabel: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateLabel: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountLabel: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstLabel: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyLabel: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueLabel: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByLabel: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyLabel: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateLabel: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyLabel: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnLabel: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertLabel: Hooks['useUpsert'] = hooks.useUpsert;
